/*!
 * Copyright 2019 Dmitry Chuba
 */

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    'use strict';

    const objectSingleKeyValue = function (object) {
        if ($.isPlainObject(object)) {

            for (let key in object) {
                return {key, val : object[key]};
            }
        }
        return null;
    };

    const isValueSelectedValues = function (elements, value) {
        let values = [];

        elements.map(function () {
            values.push($(this).val());
        });

        return values.indexOf(value) !== -1;
    };

    const trueFalseArray = function (array, orAndMode, key) {
        key       = key || false;
        orAndMode = orAndMode && ['or', 'and'].indexOf(orAndMode) !== -1 ? orAndMode : 'or';
        for (let k in array) {

            let el = array[k];
            if (key !== false && typeof array[k][key] !== 'undefined') {
                el = array[k][key];
            }
            if (orAndMode == 'or' && !!el === true) {
                return true;
            } else if (orAndMode == 'and' && !!el === false) {
                return false;
            }
        }
        if (orAndMode == 'or') {
            return false;
        } else if (orAndMode == 'and') {
            return true;
        }
    };


    $.fn.conditionalFields = function (options) {

        let settings = $.extend({
            duration : 200,
        }, options);

        return this.each(function () {
            const form              = $(this);
            let allListenedElements = [];
            form.find('[data-conditional]').each(function () {
                const element        = $(this);
                let conditions       = element.data('conditional');
                let keyVal           = {},
                    conditionsMatch  = [],
                    listenedElements = [];

                let props = {
                    relation_or      : typeof conditions['OR'] !== 'undefined',
                    relation_and     : typeof conditions['AND'] !== 'undefined' || $.isArray(conditions),
                    single_condition : $.isPlainObject(conditions) && typeof conditions['OR'] === 'undefined' && typeof conditions['AND'] === 'undefined'
                };

                if (props.relation_or) {
                    conditions = conditions['OR'];
                } else if (props.relation_and && typeof conditions['AND'] !== 'undefined') {
                    conditions = conditions['AND'];
                }

                if (!$.isArray(conditions)) {
                    conditions = [conditions];
                }

                for (let i in conditions) {

                    let {key : selector,} = objectSingleKeyValue(conditions[i]);

                    if (keyVal === null) continue;

                    if (listenedElements.indexOf(selector) == -1) {
                        listenedElements.push(selector);
                    }
                    if (allListenedElements.indexOf(selector) == -1) {
                        allListenedElements.push(selector);
                    }
                }
                $('body').on('change input', listenedElements.join(','), function (e) {
                    conditionsMatch = [];

                    for (let i in conditions) {
                        let {key : selector, val : value} = objectSingleKeyValue(conditions[i]);
                        if (keyVal === null) continue;

                        let isRadio    = $(selector).is(':radio'),
                            isSelect   = $(selector).is('select'),
                            isCheckbox = $(selector).is(':checkbox'),
                            isMultiple = selector.indexOf('[]') !== -1;

                        if (
                            (isRadio && value == $(selector + ':checked').val())
                            ||
                            (!isRadio && !isCheckbox && value == $(selector).val())
                            ||
                            (value !== ':unchecked' && isCheckbox && !isMultiple && $(selector).is(':checked'))
                            ||
                            (value === ':unchecked' && isCheckbox && !isMultiple && !$(selector).is(':checked'))
                            ||
                            (isCheckbox && isMultiple && isValueSelectedValues($(selector + ':checked'), value))
                            ||
                            (isSelect && isMultiple && $(selector).val().indexOf(value) !== -1)
                            ||
                            (!isRadio && !isCheckbox && value == ':not-empty' && $(selector).val().length > 0)
                        ) {
                            conditionsMatch.push(true);
                        } else {
                            conditionsMatch.push(false);
                        }
                    }
                    if (trueFalseArray(conditionsMatch, props.relation_or ? 'or' : 'and')) {
                        element.slideDown(settings.duration);
                    } else {
                        element.slideUp(settings.duration);
                    }

                });
            });

            $(allListenedElements.join(','))
                .trigger('change')
                .trigger('input');
        });
    };
}));
